export type CarrierType = 'US' | 'EUROPE' | 'UK' | 'GLOBAL';

export interface CarrierRoamingData {
  name: string;
  type: CarrierType;
  dailyFeeUSD: number;
  dataLimit?: string;
  notes?: string;
}

export const ROAMING_BENCHMARKS: CarrierRoamingData[] = [
  {
    name: 'AT&T / Verizon / T-Mobile (International Day Pass)',
    type: 'US',
    dailyFeeUSD: 10.00,
    dataLimit: 'Shares Plan Data',
    notes: 'Standard daily fee for US customers traveling abroad.'
  },
  {
    name: 'Major European Carrier',
    type: 'EUROPE',
    dailyFeeUSD: 5.50,
    dataLimit: 'Variable',
    notes: 'Average daily roaming fee for EU customers outside the EU.'
  },
  {
    name: 'British Carrier (EE/Vodafone/O2)',
    type: 'UK',
    dailyFeeUSD: 3.25, // Approx £2.50
    dataLimit: 'Variable',
    notes: 'Standard Roam Like Home fee for UK customers.'
  },
  {
    name: 'Global Average Roaming',
    type: 'GLOBAL',
    dailyFeeUSD: 8.50,
    dataLimit: 'Premium Data',
    notes: 'Global average for high-speed roaming daily passes.'
  }
];

export function getBenchmarkForCarrier(type: CarrierType): CarrierRoamingData {
  return ROAMING_BENCHMARKS.find(c => c.type === type) || ROAMING_BENCHMARKS[3];
}
